import Vue from "vue";
//手机号码格式化 (中间四位显示为*号)
Vue.filter("phoneNum", val => {
    if (typeof val !== "string") {
        let str = val.toString();
        return str.substr(0, 3) + "****" + str.substr(7);
    } else {
        let str = val.substr(0, 3) + "****" + val.substr(7);
        return str;
    }
});

//单位净值 保留 4位小数
Vue.filter("navFixed", val => {
    if (typeof val == "object") {
        return '--';
    } else {
        return Number(val).toFixed(4);
    }
});
Vue.filter("navFixed2", val => {
    if (typeof val == "object") {
        return '--';
    } else {
        return Number(val).toFixed(2);
    }
});
//保留两位小数
Vue.filter("dateFixed", val => {
    if (typeof val == "object") {
        return '--';
    } else {
        return Number(val).toFixed(2);
    }
});


/*
基金状态
fundSt: 
0：开发申购 
1：认购期  
5：暂停申购  
6：停止赎回   

0：开发申购；
1：认购期；
4：停止交易；
5：停止申购；
6：停止赎回(单个基金持仓时不为空)

*/
Vue.filter("applyType", val => {
    if (val == '0') {
        return '正常申赎 ';
    } else if (val == '4') {
        return '停止交易';
    } else if (val == '5') {
        return '暂停申购';
    } else if (val == '6') {
        return '停止赎回';
    } else if (val == 'a') {
        return '基金终止';
    } else {
        return '--';
    }
});
Vue.filter("tradeStatus", val => {
    if (val == '0') {
        return '可申购、可赎回、可定投';
    } else if (val == '4' || val == '6' || val == '5' || val == 'a') {
        return '暂停申购、暂停赎回、暂停定投';
    } else {
        return '--';
    }
});

//格式化时间
Vue.filter('dateFormat', function(value, fmt) {
    if (value == '--') {
        return '--';
    } else {
        let getDate = new Date(value);
        let o = {
            'M+': getDate.getMonth() + 1,
            'd+': getDate.getDate(),
            'h+': getDate.getHours(),
            'm+': getDate.getMinutes(),
            's+': getDate.getSeconds(),
            'q+': Math.floor((getDate.getMonth() + 3) / 3),
            'S': getDate.getMilliseconds()
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (let k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
            }
        }
        return fmt;
    }
});


// WEBPACK FOOTER //
// ./src/utils/filters.js